var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bdsharebuttonbox"},_vm._l((_vm.defaultConfig.shareList),function(item){return _c('a',{key:item.id,class:'bds_'+item,attrs:{"data-cmd":item}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-69ef558c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/lib/vshare.vue
// module id = 4
// module chunks = 0